module.exports = __webpack_public_path__ + "more.93d72003.png";